export enum BillingStatusEnum {
  PENDING = 'PENDING',
  PAID = 'PAID',
}

export const BILLING_STATUS = {
  [BillingStatusEnum.PENDING]: 'รอการชำระ',
  [BillingStatusEnum.PAID]: 'ชำระเงินแล้ว',
}
